import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNumberId } from "/app/src/hooks/useNumberId";

/**
 * DataButton component renders a navigation link to a report.
 * @returns {JSX.Element} The NavLink element linking to the report page.
 */
export default function DataButton() {
  const { t } = useTranslation();
  const { reportId } = useNumberId();
  return (
    <NavLink end to={`/reports/${reportId}`}>
      {t("translation:data")}
    </NavLink>
  );
}
